import LoginIcon from "@mui/icons-material/Login";
import { Box, Button } from "@mui/material";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import apiSlice from "../../../../../app/api/apiSlice";
import { useAuth } from "../../../../auth/AuthContext";

export const LoginAsButton = ({ userId }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const { signInAsUser, isSigningInAsUser, loginAsUserId } = useAuth();

	const handleClick = async () => {
		try {
			const user = await signInAsUser(userId);

			if (user) {
				dispatch(apiSlice.util.resetApiState());
				setTimeout(() => {
					navigate("/");
				}, 500);
			}
		} catch (error) {
			if (error?.data?.errors) {
				const errors = error.data.errors;
				Object.entries(errors).forEach(([_key, message]) => {
					enqueueSnackbar(message[0], {
						variant: "error",
						preventDuplicate: true,
					});
				});
			} else {
				enqueueSnackbar(error?.data?.message || t("default_error"), {
					variant: "error",
					preventDuplicate: true,
				});
			}
		}
	};

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				padding: "4px",
				border: "1px solid rgba(224, 224, 224, 1)",
				borderRadius: "4px",
				cursor: "pointer",
				height: "27px",
				width: "27px",
			}}
		>
			<Button
				aria-label="login as user"
				size="small"
				onClick={handleClick}
				loading={isSigningInAsUser && loginAsUserId === userId}
			>
				<LoginIcon sx={{ fontSize: "17px" }} />
			</Button>
		</Box>
	);
};
